module.exports = __webpack_public_path__ + "img/cloud-hail-mixed.25d60d7f.svg";